<template>
  <div class="menu">
    <div class="select-container" v-if="curr">
      <Select2
        class="select2 single currency-select"
        v-model="curr"
        @select="selectCurr($event)"
        :placeholder="curr"
        :options="currOptions"
      />
    </div>
    <ul class="nav">
      <li class="nav__item">
        <a @click="$parent.goToRules">
          <span class="desc">Rules</span>
        </a>
      </li>
      <li class="nav__item">
        <router-link to="/contacts" class="desc"> Contact us </router-link>
      </li>
      <li class="nav__item">
        <router-link :to="'/store' + activeCategory.url" class="desc">
          Store
        </router-link>
      </li>
    </ul>
    <button @click="copyIp" class="button">
      {{ ipCopied ? "IP copied" : "Join server" }}
    </button>
  </div>
</template>

<script>
export default {
  name: "Menu",
  props: ["activeCategory", "currencyCode"],
  data: function () {
    return {
      curr: "",
      ipCopied: false,
    };
  },
  computed: {
    currOptions() {
      return this.$parent.currencyOptions.map(({ text }) => text);
    },
  },
  watch: {
    currencyCode: function (newValue) {
      this.curr = newValue;
    },
  },
  mounted() {
    this.curr = this.currencyCode;
  },
  methods: {
    copyIp() {
      let self = this;
      var textarea = document.createElement("textarea");
      textarea.value = self.$parent.ip;
      document.body.appendChild(textarea);

      textarea.select();
      document.execCommand("copy");

      document.body.removeChild(textarea);
      self.ipCopied = true;

      setTimeout(() => {
        self.ipCopied = false;
      }, 2000);
    },
    openSignIn() {
      this.$router.push({ path: "/login" });
    },
    openSignUp() {
      this.$router.push({ path: "/registration" });
    },
    selectCurr(event) {
      this.curr = event.text;
      this.changeCurrency(event.text);
      localStorage.setItem("currency", event.text);
    },
    changeCurrency(item) {
      this.$emit("changeCurrency", item);
    },
  },
};
</script>
